import {
	FilterTypeKey,
	FilterType,
	INumberFilter,
	IStringFilter,
	IEnumFilter,
	IBooleanFilter,
} from '../../components/filters-menu/filters';

export const bidderModelFilters = new Map<FilterTypeKey, FilterType>([
	[
		'stringFilters',
		{
			modelName: { columnName: 'Model Name', cellKey: 'modelName' },
			campaigns: { columnName: 'Campaigns', cellKey: 'campaigns' },
			lastSuccessfulBuild: { columnName: 'Last Successful Build', cellKey: 'lastSuccessfulBuild' },
		} as IStringFilter,
	],
	[
		'numberFilters',
		{
			realAdvertiserId: { columnName: 'Real Advertiser ID', cellKey: 'realAdvertiserId', isClientFilter: true },
		} as INumberFilter,
	],
	[
		'enumFilters',
		{
			status: {
				columnName: 'Status',
				cellKey: 'status',
				enumOptions: [
					{ value: 'ACTIVE', label: 'ACTIVE' },
					{ value: 'PAUSED', label: 'PAUSED' },
				],
				deletable: true,
			},
		} as IEnumFilter,
	],
	[
		'booleanFilters',
		{
			shouldBuild: { columnName: 'Should Build', cellKey: 'shouldBuild', value: true },
		} as IBooleanFilter,
	],
]);
